import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import dev.terrakok.mapitan.App
import kotlinx.browser.window
import org.maplibre.compose.browser.installMapLibreCompose

@OptIn(ExperimentalComposeUiApi::class)
fun main() = ComposeViewport {
    LaunchedEffect(Unit) {
        installMapLibreCompose()
    }
    App(
        deeplink = window.location.toString()
    )
}
